export default {
	title: "Mi Perfil",
	tabs: {
		personal: "Datos Personales",
		religious: "Religioso",
		security: "Seguridad",
	},
	fields: {
		displayName: "Nombre para mostrar",
		email: "Correo electrónico",
		phone: "Teléfono",
		whatsappOptIn: "Recibir alertas del ORI por WhatsApp",
		whatsappOptInHint: "Avisos de gestión del templo (pagos recibidos, gastos, cierre) enviados desde el número oficial del ORI al teléfono indicado arriba",
		religiousName: "Nombre religioso",
		title: "Título",
		ritualFunction: "Función ritual",
		role: "Rol en el templo",
		currentPassword: "Contraseña actual",
		newPassword: "Nueva contraseña",
		confirmPassword: "Confirmar nueva contraseña",
	},
	photo: {
		change: "Cambiar foto",
		remove: "Eliminar foto",
	},
	messages: {
		saved: "Perfil actualizado con éxito",
		photoUploaded: "Foto actualizada con éxito",
		photoRemoved: "Foto eliminada con éxito",
		errorSaving: "Error al guardar perfil",
		errorPhoto: "Error al actualizar foto",
		changePassword: "Cambiar Contraseña",
		passwordChanged: "Contraseña cambiada con éxito",
		passwordsDoNotMatch: "Las contraseñas no coinciden",
		wrongCurrentPassword: "La contraseña actual es incorrecta",
	},
	stats: {
		temple: "Templo",
	},
};
